import { useTranslation } from 'react-i18next'
import CMSTemplate from '../../../components/cms-template'
import CMS from '../../../components/cms/CMS'
import PageBanner from '../../../components/general/PageBanner'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchPageGetSlug } from '../../../redux/slices/pageGetSlugSlice'
import { useSelector } from 'react-redux'
import Circular from '../../../components/general/Circular'
import { changeTemplate } from '../../../redux/slices/templateSlice'

const PageSave = () => {
    const { t } = useTranslation()
    const { slug } = useParams()
    const page = useSelector((state) => state.pageGetSlug.data)
    const dispatch = useDispatch()

    const getData = async () => {
        await dispatch(fetchPageGetSlug({ slug: slug }))
    }

    useEffect(() => {
        dispatch(changeTemplate(0))
    }, [slug])

    useEffect(() => { getData() }, [dispatch])

    return (
        <CMS>
            <PageBanner
                title={t("page_management")}
                description={t("page_management_desc")}
            />
            {page || !slug ? <CMSTemplate page={page} slug={slug} /> : <Circular />}
        </CMS>
    )
}

export default PageSave